import { Box, 
    useColorModeValue} from '@chakra-ui/react'

import React from 'react'
import Draggable from 'react-draggable'
import Outgoingpiechart from '../../components/Outgoingpiechart'
import { IContext, TextContext } from '../../hooks/context'
import "./index.css"

const Transaction = () => {
  const transact= useColorModeValue("white","#1A202C")
    const {list,address,totalOutgoing,totalIncoming,outgoingData,incomingData} = React.useContext(TextContext) as IContext
  return (
    <>
    {list.length >0 && 
    // <Draggable>
        <Box>
<Box py="6px" >

<Outgoingpiechart out={totalOutgoing} ins={totalIncoming}  />

    </Box> 
    </Box>
   

    }
    </>
  )
}

export default Transaction